import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

// Default config values - MUST match production database values to prevent flash
const defaultConfig = {
  business_name: "Overhaul Ops LLC",
  client_name: "Aaron Harper",
  client_email: "overhaulops.llc@gmail.com",
  client_phone: "8176821555",
  domain_name: "overhaulops.com",
  formatted_phone: "(817) 682-1555",
  phone_link: "tel:8176821555",
  google_review_url: "https://g.page/r/CeT6wm1so9n5EAI/review",
  facebook_url: "",
  instagram_url: "",
  youtube_url: "",
  linkedin_url: "",
  tiktok_url: "",
  nextdoor_url: "",
  yelp_url: "",
  google_business_url: "",
  google_maps_api_key: "",
  google_business_place_id: ""
};

const SiteConfigContext = createContext(defaultConfig);

export function SiteConfigProvider({ children }) {
  const [config, setConfig] = useState(defaultConfig);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        // Fetch public settings (no auth required)
        const res = await axios.get(`${API}/api/public/settings`);
        if (res.data) {
          const phone = res.data.client_phone || defaultConfig.client_phone;
          // Format phone number for display: (XXX) XXX-XXXX
          const cleanPhone = phone.replace(/\D/g, '');
          const formattedPhone = cleanPhone.length === 10 
            ? `(${cleanPhone.slice(0,3)}) ${cleanPhone.slice(3,6)}-${cleanPhone.slice(6)}`
            : phone;
          
          setConfig({
            ...defaultConfig,
            ...res.data,
            formatted_phone: formattedPhone,
            phone_link: `tel:${cleanPhone}`
          });
        }
      } catch (error) {
        console.log("Using default config");
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  return (
    <SiteConfigContext.Provider value={{ ...config, loading }}>
      {children}
    </SiteConfigContext.Provider>
  );
}

export function useSiteConfig() {
  return useContext(SiteConfigContext);
}
